import { MenuItem, TextField } from "@mui/material";
import { useMemo } from "react";
import { useGetRolesQuery } from "src/api/services/rolesApi";
import { FilterProps } from "src/api/types";

const RolesFilter = ({ filter, onChange, placeholder }: FilterProps) => {
  const { data = [] } = useGetRolesQuery();

  const roles = useMemo(() => {
    return data.filter((r) => r.name != "Patient");
  }, [data]);

  return (
    <TextField
      label={placeholder}
      select
      sx={{ width: 180 }}
      size="small"
      value={filter}
      onChange={onChange}
    >
      <MenuItem value={""}>{"None"}</MenuItem>
      {roles.map((role) => (
        <MenuItem key={role.id} value={role.name}>
          {role.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default RolesFilter;
